import * as cloudinary from './cloudinary'
import * as date from './date'
import * as order from './order'

export default {
  date,
  cloudinary,
  order,
}
